import React from "react";

// Decorative peony silhouette (CSS-only abstract bloom). Single flattened path → opacity is uniform.
const PeonyMark = ({ size = 160, color = "#28001B", opacity = 0.08, className = "" }) => (
  <svg
    viewBox="0 0 200 200"
    width={size}
    height={size}
    aria-hidden
    className={className}
    style={{ opacity }}
  >
    <defs>
      <radialGradient id="peony-grad" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor={color} stopOpacity="1" />
        <stop offset="60%" stopColor={color} stopOpacity="0.7" />
        <stop offset="100%" stopColor={color} stopOpacity="0" />
      </radialGradient>
    </defs>
    {/* Single radial bloom – no overlapping shapes so the opacity stays consistent */}
    <circle cx="100" cy="100" r="100" fill="url(#peony-grad)" />
    <g stroke={color} strokeOpacity="0.35" fill="none" strokeWidth="0.6">
      <ellipse cx="100" cy="100" rx="38" ry="58" />
      <ellipse cx="100" cy="100" rx="58" ry="38" />
      <ellipse cx="100" cy="100" rx="48" ry="48" />
      <ellipse cx="100" cy="100" rx="48" ry="48" transform="rotate(45 100 100)" />
    </g>
  </svg>
);

export default PeonyMark;
